import { Option } from "../../types/commonElements";

export const appointmentTimeDurationOptions: Option[] = [
  { label: "10 Minutes", value: "10" },
];

export const procedureTimeDurationOptions: Option[] = [
  { label: "20 Minutes", value: "20" },
];
export const selectSexOptions: Option[] = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
];

export const appointmentPurposeOptions: Option[] = [
  { label: "Consultation", value: 0 },
  { label: "Procedure", value: 1 },
];

export const appointmentTypeOptions: Option[] = [
  { label: "Walk-in", value: 1 },
  { label: "Pre Booking", value: 0 },
];

export const gstOptions: Option[] = [
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
];

export const patientSourceOptions: Option[] = [
  { label: "Instagram", value: "instagram" },
  { label: "Facebook", value: "facebook" },
  { label: "Friends", value: "friends" },
  { label: "Youtube", value: "youtube" },
];

export const consultationOptions: Option[] = [
  { label: "Followup Case", value: 2 },
  { label: "New Case", value: 1 },
];

export const modeOfPaymentOptions: Option[] = [
  { label: "Cash", value: "Cash" },
  { label: "Credit/Debit Card", value: "Credit/Debit Card" },
  { label: "UPI", value: "UPI" },
];

export const paymentOptions: Option[] = [
  { label: "Online", value: "online" },
  { label: "Offline", value: "offline" },
];

export const paymentTypeOptions: Option[] = [
  { label: "Payment", value: "Payment" },
  { label: "Refund", value: "Refund" },
];

export const whenOptions: Option[] = [
  { label: "Before lunch", value: "Before lunch" },
  { label: "After lunch", value: "After lunch" },
  { label: "Before meal", value: "Before meal" },
  { label: "After meal", value: "After meal" },
];
